import * as React from "react";

import { AgentLaunchOverview } from "@v2/features/agent-beta/AgentLaunchOverview";

/** The Replo Agent upsell as the cancel flow's retention step: the launch modal's body and its note. */
export function CancellationAgentOffer() {
  return (
    <div className="flex flex-col gap-4">
      <AgentLaunchOverview />
      <p className="text-xs leading-tight text-placeholder">
        Creates a new project. None of your existing projects are impacted, and
        your current plan won't change.
      </p>
    </div>
  );
}
